import { getCustomerJobGroupsAsPublicRemote } from '@flex-apis/recruiting';
import { useQueryFromRemote } from '@flex-packages/remote-hooks';

function useGetCustomerJobGroupsAsPublicRemote(requestParams, options) {
  return useQueryFromRemote({
    remote: getCustomerJobGroupsAsPublicRemote,
    extraParams: requestParams,
    options
  });
}

export { useGetCustomerJobGroupsAsPublicRemote };
//# sourceMappingURL=useGetCustomerJobGroupsAsPublicRemote.mjs.map
